module.exports = __webpack_public_path__ + "img/man_facepalming.8f162fd8.gif";